import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, App } from 'ionic-angular';
import { HomePage } from "../home/home";
import { LoginPage } from "../login/login";
import { Configuration } from '../../constants/config';
import { InvoiceServiceProvider } from '../../providers/invoice-service/invoice-service';

/**
 * Generated class for the PaymentConfirmationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-payment-confirmation',
    templateUrl: 'payment-confirmation.html',
})
export class PaymentConfirmationPage {

    email = "";
    sellItems = [];
    total = 0;
    numItems = 0;
    totalItems = 0;
    totalTaxofItems = 0;
    paymentDetails : any = {};
    paymentType = 1;
    employeeData : any = {};
    applyForDiscount : boolean = false;
    totalDiscount = 0;
    paymentDetailsStr = "";
    todayDate = null;

    constructor(public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController, public invoiceService: InvoiceServiceProvider, private app: App, public _configuration: Configuration) {
        this.sellItems = this.navParams.data.sellItems;
        this.paymentDetails = this.navParams.data.paymentDetails;
        this.paymentType = this.navParams.data.paymentDetails.paymentType == 3 ? 2:1;
        this.applyForDiscount = this.navParams.data.paymentDetails.applyForDiscount;
        this.employeeData = this.navParams.data.paymentDetails.employeeData;
        this.todayDate = new Date();

        this.getTotals();
    }


    /**
     * @Info Get all totals
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    getTotals(){
        this.numItems = 0;
        this.totalItems = 0;
        this.totalTaxofItems = 0;
        this.total = 0;
        this.totalDiscount = 0;
        if (this.sellItems.length > 0) {
            this.sellItems.forEach(item => {
                this.numItems = this.numItems + item.quantity;
                this.totalDiscount = this.totalDiscount + item.totalItemDiscount;
                if (this.applyForDiscount && item.unitPriceWD){
                    //this.totalItems = this.totalItems + item.totalPriceAllItemsWithoutTaxWD;
                    this.totalItems = this.totalItems + item.totalPriceAllItemsWithoutTax;

                    this.totalTaxofItems = this.totalTaxofItems + item.totalTaxWD;
                    this.total = this.total + item.totalWD;
                }else{
                    this.totalItems = this.totalItems + item.totalPriceAllItemsWithoutTax;
                    this.totalTaxofItems = this.totalTaxofItems + item.totalTax;
                    this.total = this.total + item.total;
                }
            });
        }
    }


    /**
     * @Info Send email to customer
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-23
     */
    sendEmail(){

        let idBranch = 1; //?
        /*
        let idUser = 1;
        if (this._configuration.isLogged){
            idUser = this._configuration.CustomerData.IdUser;
        }
         */

        if (!this.email) {
            let toast = this.toastCtrl.create({message: "Enter a valid Email address",position: 'middle',duration: 3000});
            toast.present();
        }else{
            let data = {
                IdInvoice: 0,
                InvoiceNBR: this.paymentDetails.invoiceNumber,
                Email : this.email,
                IdBranch: idBranch,
                token: this._configuration.token
            };
            this.invoiceService.sendEmailInvoice(data)
                .then(data => {
                    let response : any = data;
                    if (!response.Error){
                        if (response.Success){
                            //this.finish();
                        }else{
                            //let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                            //toast.present();
                        }
                    }else{
                        //let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                        //toast.present();
                    }
                });
            this.finish();
        }
    }


    /**
     * @Info Finish purchase
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-23
     */
    finish(){
        if (this._configuration.isLogged){
            this.app.getRootNav().setRoot(HomePage);
        }else{
            this.app.getRootNav().setRoot(LoginPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/payment-confirmation/payment-confirmation.ts